<template>
  <div class="page-container">
    <a-layout-content style="flex:none">
      <a-breadcrumb>
        <a-breadcrumb-item>系统设置</a-breadcrumb-item>
        <a-breadcrumb-item>个人管理</a-breadcrumb-item>
        <a-breadcrumb-item>项目追踪</a-breadcrumb-item>
      </a-breadcrumb>
    </a-layout-content>
    <div class="page-tip" v-if="showTip">
      天池新推出<strong>追踪项目</strong>功能，可以帮助大家更好的管理和接收自己关心项目的各类外部信息，关注项目后巡天机器人可以给大家自动推送关心的信息。
    </div>
    <div class="header">
      <div class="header-left">
        <a-button type="primary" class="button" @click="openTraceModal"> <a-icon type="setting" /> 追踪设置</a-button>
        <a-button type="primary" :disabled="this.rowSelectionConfig.selectedRowKeys.length < 1" @click="cancelTrace"
          ><a-icon type="user-delete" />取消追踪</a-button
        >
      </div>
      <div class="header-right">
        <a-input-search placeholder="筛选公司项目" style="width: 200px" @search="onSearch" v-model="keyword" />
      </div>
    </div>
    <div class="content" ref="contentTable">
      <a-table
        :scroll="{ y: tableHeight - 70 }"
        rowKey="companyId"
        :row-selection="rowSelectionConfig"
        :columns="columns"
        :data-source="traceList"
        :loading="tableLoading"
        :pagination="false"
      >
        <div class="table-company" slot="company" slot-scope="text, record">
          <a-avatar shape="square" size="small" :src="record.logo" />
          <a-tooltip>
            <template slot="title">
              {{ text }}
            </template>
            <router-link :to="{ path: '/project/detail', query: { id: record.companyId } }"> {{ text }}</router-link>
          </a-tooltip>
        </div>
        <div slot="dlDms" class="text-ellipsis" slot-scope="text">
          <a-tooltip>
            <template slot="title">
              {{ text && text.join && text.join(',') }}
            </template>
            <span>{{ text && text.join && text.join(',') }}</span>
          </a-tooltip>
        </div>
        <div class="table-description" slot="description" slot-scope="text">
          <a-tooltip>
            <template slot="title">
              {{ text }}
            </template>
            {{ text }}
          </a-tooltip>
        </div>
        <div slot="xiniu" slot-scope="text, record">
          <a-tooltip v-if="text">
            <template slot="title">
              {{ text }}
            </template>
            <a :href="record.xiniuUrl">{{ text }} <a-icon type="link"/></a>
          </a-tooltip>
          <a v-else style="color: red;" @click="openBindModal(record)">未绑定 <a-icon type="edit"/></a>
        </div>
      </a-table>
    </div>
    <a-modal :visible="modalVisible" title="自动追踪设置" @ok="handleModalOk" @cancel="handleModalCancle" class="modal">
      <div class="modal-title">
        1. 设置『巡天机器人信息推送』
      </div>
      <a-checkbox-group v-model="traceTourskys" name="checkboxgroup">
        <div v-for="option in traceSetting.tourskysOptions" :key="option.value" class="checkbox-container">
          <a-checkbox :disabled="option.disabled" :value="option.value">
            {{ option.text }}
          </a-checkbox>
        </div>
      </a-checkbox-group>
      <div class="modal-footer">后续支持更多信息推送， 有其他需求欢迎<a @click="feedbackVisible = true">点击告知我们</a></div>
      <div class="modal-title">
        2. 设置『自动追踪规则』
      </div>
      <a-checkbox-group v-model="traceRoules" name="checkboxgroup">
        <div v-for="option in traceSetting.rulesOptions" :key="option.value" class="checkbox-container">
          <a-checkbox :disabled="option.disabled" :value="option.value">
            {{ option.text }}
          </a-checkbox>
        </div>
      </a-checkbox-group>
      <div class="modal-footer">后续支持更多自动规则， 有其他需求欢迎 <a @click="feedbackVisible = true">点击告知我们</a></div>
    </a-modal>
    <a-modal :visible="bindModal.visible" title="绑定" @ok="bindModalOk" @cancel="bindModalCancle" class="modal">
      <thirdCompanySelect style="width: 100%;" :value="bindModal.value" @change="changeCompany"></thirdCompanySelect>
    </a-modal>
    <feedback v-model="feedbackVisible"></feedback>
  </div>
</template>
<script>
import { getTraceList, traceSiteQuery, setTraceSite, traceArtificial } from '@/api/trace.js';
import { thirdsourceBindSync } from '@/api/project';
import moment from 'moment';
import { Modal } from 'ant-design-vue';
import thirdCompanySelect from '@/components/base/thirdCompanySelect.vue';
import feedback from '@/components/base/feedback';
export default {
  components: {
    thirdCompanySelect,
    feedback
  },
  data() {
    let showTip = moment().isBefore('2023-4-1');
    return {
      modalVisible: false,
      feedbackVisible: false,
      showTip,
      columns: [
        {
          title: '公司/项目名称',
          dataIndex: 'companyName',
          scopedSlots: { customRender: 'company' }
        },
        {
          title: '业务',
          dataIndex: 'description',
          scopedSlots: {
            customRender: 'description'
          }
        },
        {
          title: 'sector',
          dataIndex: 'sectorName',
          width: 120
        },
        {
          title: '币种',
          dataIndex: 'currency',
          width: 120
        },
        {
          title: 'DL/DM',
          dataIndex: 'dlDms',
          scopedSlots: {
            customRender: 'dlDms'
          },
          width: 120
        },
        {
          title: '项目阶段',
          dataIndex: 'stateName',
          width: 100
        },

        {
          title: '开始追踪日期',
          dataIndex: 'traceTime',
          customRender: time => moment(time * 1000).format('YYYY-MM-DD'),
          width: 120
        },
        {
          title: '追踪类型',
          width: 90,
          dataIndex: 'traceType'
        },
        {
          title: '绑定烯牛',
          dataIndex: 'xiniuName',
          scopedSlots: {
            customRender: 'xiniu'
          }
        }
      ],
      tableLoading: false,
      tableHeight: 300,
      traceList: [],
      keyword: '',
      rowSelectionConfig: {
        type: 'checkbox',
        selectedRowKeys: [],
        onChange: (...args) => {
          console.log('sss', args);
          this.rowSelectionChange(...args);
        }
      },
      paginationConfig: {
        total: 0,
        change: (...args) => {
          this.changePage(...args);
        }
      },
      traceSetting: {
        tourskysOptions: [
          {
            value: 1,
            text: '公司新的一轮投融资信息',
            disabled: false
          },
          {
            value: 2,
            text: '公司相关新闻资讯（稍后升级支持）',
            disabled: true
          },
          {
            value: 3,
            text: '公司工商信息变更（稍后升级支持）',
            disabled: true
          }
        ],
        rulesOptions: [
          {
            value: 1,
            text: '自动追踪所有『我创建的公司』',
            disabled: false
          },
          {
            value: 2,
            text: '自动追踪所有『我是DL或DM的公司』',
            disabled: false
          },
          {
            value: 3,
            text: ' 自动追踪所有「我是项目组成员的公司」',
            disabled: false
          },
          {
            value: 4,
            text: '自动追踪所有「我发布过工作进展的公司」',
            disabled: false
          }
          // {
          //   value: 5,
          //   text: '自动追踪所有『Portfolio』',
          //   disabled: false
          // }
        ]
      },
      traceTourskys: [],
      traceRoules: [],
      bindModal: {
        visible: false,
        value: '',
        data: {
          companyId: ''
        },
        thirdCompany: {}
      }
    };
  },
  mounted() {
    this.getTraceList();
    this.getTraceSiteQuery();
    this.setContentTableHeight();
    window.addEventListener('resize', this.setContentTableHeight);
  },
  destoryed() {
    console.log('destory, sss');
    window.removeEventListener('resize', this.setContentTableHeight);
  },
  methods: {
    onSearch() {
      this.paginationConfig.page = 1;
      this.$set(this.rowSelectionConfig, 'selectedRowKeys', []);
      this.getTraceList();
    },
    setContentTableHeight() {
      if (this.$refs.contentTable) {
        this.tableHeight = this.$refs.contentTable.offsetHeight;
      }
    },
    getTraceSiteQuery() {
      traceSiteQuery().then(res => {
        this.traceTourskys = res.data.tourskys;
        this.traceRoules = res.data.rules;
      });
    },
    async setTraceSite() {
      return await setTraceSite({
        tourskys: this.traceTourskys.join(','),
        rules: this.traceRoules.join(',')
      }).then(res => {
        if (res.code) {
          return true;
        } else {
          return false;
        }
      });
    },
    async getTraceList() {
      this.tableLoading = true;
      let page = 1;
      let pageSize = 250;
      this.traceList = [];
      try {
        while (true) {
          let res = await getTraceList({
            page: page,
            pageSize,
            searchWord: this.keyword
          });
          if (res.code === 200) {
            this.traceList = this.traceList.concat(res.data.list || []);
            this.paginationConfig.total = res.data.total;
            this.tableLoading = false;
            if (this.traceList.length >= this.paginationConfig.total) {
              break;
            }
          } else {
            break;
          }
          page++;
        }
      } catch (e) {
      } finally {
        this.tableLoading = false;
      }
    },
    openTraceModal() {
      this.modalVisible = true;
      this.getTraceSiteQuery();
    },
    async handleModalOk() {
      let res = await this.setTraceSite();
      if (res) {
        this.modalVisible = false;
        this.onSearch();
      }
    },
    handleModalCancle() {
      this.modalVisible = false;
    },
    rowSelectionChange(rowKeys) {
      console.log('rowselected', rowKeys);
      this.$set(this.rowSelectionConfig, 'selectedRowKeys', rowKeys);
    },
    cancelTrace() {
      console.log('cancle');
      Modal.confirm({
        icon: () => <a-icon style="color: red" type="exclamation-circle" theme="filled" />,
        title: `确认取消追踪这${this.rowSelectionConfig.selectedRowKeys.length}个项目/公司吗？`,
        // JSX support
        content: (
          <p>
            取消追踪后，这些公司不会再因命中自动追踪规则而加入追踪，{' '}
            <span style="color: red">如果改变主意还想继续追踪，需要人工手动到该项目页面点击『+追踪』 按钮</span>, 请知晓!
          </p>
        ),
        onOk: () => {
          return traceArtificial({
            type: 2,
            companyIds: this.rowSelectionConfig.selectedRowKeys.join(',')
          }).then(res => {
            if (res.code === 200) {
              this.onSearch();
              return true;
            }
          });
        }
      });
    },
    openBindModal(item) {
      this.bindModal.visible = true;
      this.bindModal.data = item;
      this.bindModal.value = '';
    },
    bindModalOk() {
      if (this.bindModal.value) {
        thirdsourceBindSync({
          companyId: this.bindModal.data.companyId,
          companyCode: this.bindModal.thirdCompany.companyCode
        }).then(res => {
          if (res.code === 200) {
            this.bindModal.visible = false;
            this.getTraceList();
          }
        });
      }
    },
    bindModalCancle() {
      this.bindModal.visible = false;
    },
    changeCompany(company) {
      console.log('xx', company);
      this.bindModal.thirdCompany = company;
      this.bindModal.value = company.id;
    }
  }
};
</script>
<style lang="less">
.page-container {
  height: calc(100vh - 130px);
  display: flex;
  flex-direction: column;
  .page-tip {
    flex: none;
    margin: 10px 0;
    font-size: 15px;
    strong {
      font-weight: bold;
    }
  }
  .header {
    margin: 10px 0 15px 0;
    flex: none;
    display: flex;
    .header-left {
      flex: auto;
      .button {
        margin-right: 15px;
      }
    }
    .header-right {
      flex: none;
    }
  }
  .content {
    flex: auto;
    height: 0;
  }
  .text-ellipsis {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .table-description {
    .text-ellipsis;
  }
  .table-company {
    .text-ellipsis;
  }
}
.modal {
  .modal-title {
    margin: 5px 0 10px 0;
    color: #000;
  }
  .checkbox-container {
    margin-left: 15px;
  }
  .modal-footer {
    margin: 5px 0 20px 0;
    color: #000;
  }
}
</style>
